import React from 'react';
import OverlayRouter from "./routing/OverlayRouter";

interface SiteProps {
}

function Site(props: SiteProps) {

    return (
        <>
            <OverlayRouter />
        </>
    );
}

export default Site;